import React from 'react'
import { ResponsiveLine } from '@nivo/line'
import { normalizeCurrency } from '@/utils/normalize'

export const OperationGraphic: React.FC<{ data: any[] }> = ({ data }) => {
  const getColor = bar => {
    return data.find(i => i.id === bar.id)?.color || '#222'
  }
  const serieId = (v: string | number) => {
    const i = data.find(i => i.id === v)
    if (i) {
      return i.label
    }
    return ''
  }
  return (
    <ResponsiveLine
      data={data}
      margin={{ top: 10, right: 15, bottom: 50, left: 35 }}
      xScale={{ type: 'point' }}
      yScale={{
        type: 'linear',
        min: 'auto',
        max: 'auto',
        stacked: false,
        reverse: false
      }}
      enableGridY={false}
      axisTop={null}
      axisRight={null}
      curve="linear"
      colors={getColor}
      useMesh={true}
      enablePoints={false}
      lineWidth={2}
      tooltip={data => {
        return (
          <div
            className="pt-1 pb-1 pl-1 pr-1"
            style={{
              background: '#444',
              color: '#fff',
              borderRadius: '4px',
              fontSize: '0.8rem',
              position: 'relative',
              right: '50px',
              borderLeft: `5px solid ${data.point.serieColor}`
            }}
          >
            Data:{' '}
            <strong>
              {
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                data.point.data.date
              }
            </strong>
            <br />
            Quantidade:{' '}
            <strong>
              {
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                data.point.data.total
              }
            </strong>
            <br />
            Valor pago:{' '}
            <strong>
              {normalizeCurrency(
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                data.point.data.paid_value,
                true
              )}
            </strong>
          </div>
        )
      }}
    />
  )
}
